import PaymentAlias from './PaymentAlias'

export default PaymentAlias
